var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"employers_link"}},[_c('router-link',{staticClass:" font-koho text-mainColor text-base sm:text-xs lg:text-sm",attrs:{"to":"/for_employers"}},[_vm._v("EMPLOYERS")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }